import { Endpoints } from '@/api/ApiEndpoints';
import { formatDate } from "@/core/helpers/DatetimeConverter";
const Transactions = {
	Plural: 'Coins Transactions',
	Single: 'Coins Transaction',
	ModalForm: true,
	DefaultSorting: 'ID',
	DefaultSortingType: 'desc',
	Columns: [
		{
			name: '',
			label: '#',
			type: 'counter',
		},
		{
			name: 'id',
			dbName: 'id',
			label: 'ID',
			sortable: true,
			required: true,
			type: 'text',
		},
		{
			name: 'couponId',
			dbName: 'couponId',
			label: 'couponId',
			sortable: true,
			required: true,
			type: 'text',
		},
		{
			name: 'user',
			dbName: 'User',
			label: 'Name',
			sortable: true,
			required: true,
			type: 'text',
			format: (item) => {
				return item.user.nickName;
			}
		},
		{
			name: 'amount',
			dbName: 'amount',
			label: 'Amount',			
			required: true,
			type: 'text',			
		},
		{
			name: 'transactionStatus',
			dbName: 'transactionStatus',
			label: 'TransactionStatus',			
			required: true,
			type: 'text',
		},
		{
			name: 'transactionType',
			dbName: 'transactionType',
			label: 'TransactionType',			
			required: true,
			type: 'text',
		},
		{
			name: 'processedAt',
			dbName: 'processedAt',
			label: 'ProcessedAt',
			sortable: true,
			type: 'date',
			format:(item) => {
				return formatDate(item.processedAt);
			}
			
		}
	],
	Filters: [
		{
			name: 'TransactionType',
			label: 'TransactionType',
			nameToRequest: 'TransactionTypeTd',
			endpoint: Endpoints.TRANSACTIONS_FOR_FILTERS,
			type: 'groupedSelect', 
			attributes: {
				name: 'name',
				linkedAttr: 'id',
			},
			mapping: (countriesFromResponse) => {
				return countriesFromResponse;
			},
		},
	],
	PrimaryKey: 'id',
	Actions: {
		addLink: '/transactions/add/',
	},
};

export default Transactions;
